module.exports = __webpack_public_path__ + "static/media/batiste_denver_22.fd4ddcdc.png";